import React from 'react';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Stack, Typography } from '@mui/material';
import { getRobotDashboardDataAPI } from '../api/robot';
import TableAvatar from '../components/TableAvatar';

const initialState = {
  totalRobots: 0,
  totalUsers: 0,
  averageInstallBots: 0,
  robots: [],
  users: [],
  error: null,
};

export const getList = createAsyncThunk(
  'main/GET_LIST',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const { result, data } = await getRobotDashboardDataAPI({ userId });
      if (!result) {
        return rejectWithValue(`Dashboard 데이터 로드 중 에러가 발생했습니다.`);
      }
      const resultObject = {
        totalRobots: 0,
        totalUsers: 0,
        averageInstallBots: 0,
        robots: [],
        users: [],
      };
      if (data && data.length > 0) {
        const {
          totalRobots,
          totalUsers,
          averageInstallBots,
          robots: robotList,
          users: userList,
        } = data[0];
        const robots =
          robotList.length > 0
            ? robotList.map(({ id, serial, alias, group }) => {
                const serialItem = {
                  content: serial,
                  value: serial,
                  class: '',
                  key: 'serial',
                };
                const aliasItem = {
                  content: alias,
                  value: alias,
                  class: '',
                  key: 'alias',
                };
                const groupItem = {
                  content: group && 'name' in group ? group.name : '',
                  value: group && 'id' in group ? group.id : '',
                  class: '',
                  key: 'group',
                };
                return { id, items: [serialItem, aliasItem, groupItem] };
              })
            : [];

        resultObject.totalRobots = totalRobots;
        resultObject.totalUsers = totalUsers;
        resultObject.averageInstallBots = averageInstallBots;
        resultObject.robots = robots;
        resultObject.users = userList.map(({ id, name, nickName, serial }) => {
          const nameItem = {
            content: (
              <Stack flexDirection="row" alignItems="center">
                <TableAvatar uuid={id} type="subuserPhoto" sx={{ mr: 1 }} />
                <Typography>{name}</Typography>
              </Stack>
            ),
            value: name,
            class: '',
            key: 'name',
          };
          const nickNameItem = {
            content: nickName || '',
            value: nickName || '',
            class: '',
            key: 'nickName',
          };
          const serialItem = {
            content: serial || '',
            value: serial || '',
            class: '',
            key: 'serial',
          };
          return {
            id,
            items: [nameItem, nickNameItem, serialItem],
          };
        });
        return resultObject;
      }
      return {
        totalRobots: 0,
        totalUsers: 0,
        averageInstallBots: 0,
        robots: [],
        users: [],
      };
    } catch (err) {
      const { error } = await err.json();
      if ('code' in error && 'desc' in error) {
        const { desc } = error;
        return rejectWithValue(desc);
      }
      return rejectWithValue(
        '알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.',
      );
    }
  },
);

const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {},
  extraReducers: {
    [getList.pending.type]: (state) => ({ ...state, loading: true }),
    [getList.fulfilled.type]: (state, action) => ({
      ...state,
      loading: false,
      ...action.payload,
    }),
    [getList.rejected.type]: (state, action) => ({
      ...initialState,
      error: action.payload,
    }),
  },
});

const { reducer: MainReducer } = mainSlice;

export default MainReducer;
